import React, { useEffect, useRef, useState } from 'react';

import CustomDropdown from '@components/CustomDropdown';
import CustomReactSelect from '@components/CustomReactSelect';
import AddFabric from '@components/materials/AddFabric';

import ConfirmationModal from '@features/crm/components/ConfirmationModal';
import TrimsAndAccessories from '@features/materials/components/TrimsAndAccessories';

import ApiClient from '@lib/apiClient';

import { enumObj, fetchApplicationGarmentsTypeList, MATERIAL_TITLE_NAME } from '@utils/MaterialsUtil';
import { isAdmin, packTag, printApiError, setTag, validateFloatNumber } from '@utils/Util';

import { BASE_URL, MATERIAL_TYPE } from '@/constants/constant';

const SingleMaterial = ({
	materialItem,
	isAddNewItem,
	cellId,
	idx,
	type,
	designLists,
	onChangeMaterial,
	onMaterialCategoryAndUnitChange,
	onClickMaterial,
	materialsData,
	allUnitTypes,
	onAddNew,
	onEditClick,
	isEditItem,
	errors,
	onRemoveItem,
	onCancelEdit,
	onPopulateDynamicMaterials,
	editCellId,
	onDuplicateClick,
	onClickDesignImage,
	appGarments,
	supplierList,
	selectedDesign,
	onUpdatePlacement,
	setAppGarments
}) => {
	const [showAddNewModal, setIsShowNewModal] = useState(false);
	const [isSupplierChanged, setIsSupplierChanged] = useState(false);
	const [isSure, setIsSure] = useState(false);
	const [selectedPlacement, setSelectedPlacement] = useState([]);

	useEffect(() => {
		setSelectedPlacement(
			materialItem?.placementResponseList?.map((item) => ({
				...item,
				id: item?.id,
				value: item?.name,
				label: item?.name
			}))
		);
	}, [materialItem?.placementResponseList?.length]);

	const placementRef = useRef();

	const inputRef = useRef();
	const resultsRef = useRef();
	const searchRef = useRef();

	useEffect(() => {
		if (inputRef.current) {
			inputRef.current.focus();
		}
	}, []);

	useEffect(() => {
		if (materialsData) {
			document.body.addEventListener('keydown', onKeyDown);
		} else {
			document.body.removeEventListener('keydown', onKeyDown);
		}
		return () => {
			document.body.removeEventListener('keydown', onKeyDown);
		};
	}, [materialsData]);

	function onKeyDown(event) {
		const isUp = event.key === 'ArrowUp';
		const isDown = event.key === 'ArrowDown';
		const inputIsFocused = document.activeElement === inputRef.current;
		const resultsItems = Array.from(resultsRef?.current?.children || []);
		const activeResultIndex = resultsItems.findIndex((child) => {
			return child.querySelector('div') === document.activeElement;
		});

		if (isUp) {
			if (inputIsFocused) {
				resultsItems[resultsItems.length - 1].querySelector('div').focus();
			} else if (resultsItems[activeResultIndex - 1]) {
				resultsItems[activeResultIndex - 1].querySelector('div').focus();
			} else {
				searchRef.current && searchRef.current.focus();
			}
		}

		if (isDown) {
			if (inputIsFocused) {
				searchRef.current.focus();
				// resultsItems[0].querySelector('div').focus();
			} else if (resultsItems[activeResultIndex + 1]) {
				resultsItems[activeResultIndex + 1].querySelector('div').focus();
			} else {
				searchRef.current && searchRef.current.focus();
			}
		}
	}

	const isEditMaterial = () => {
		if (isEditItem && editCellId === `${idx}-editItem-${type}`) return true;
		return false;
	};
	const isAddMaterial = () => {
		if (isAddNewItem && cellId === `${idx}-newItem-${type}`) return true;
		return false;
	};

	const onCloseModal = () => {
		onPopulateDynamicMaterials(type, materialItem);
		setIsShowNewModal(false);
	};
	const onAddNewMaterialItem = () => {
		// dispatch(getFabricTypes());
		setIsShowNewModal(true);
	};

	const getSelectedPlacementIds = (placementList = []) => {
		return placementList.filter((item) => !item?.__isNew__)?.map((item) => item.id);
	};

	const createAppGarmentsType = async (newCreatedPlacement, materialType) => {
		try {
			const { data } = await ApiClient.POST(
				`${BASE_URL}/material/app-garments-types`,
				{
					materialType,
					name: newCreatedPlacement
				},
				'',
				true
			);

			const newOption = {
				...data,
				id: data.id,
				label: data.name,
				value: data.name
			};

			setSelectedPlacement((prev) => [...prev, newOption]);

			fetchApplicationGarmentsTypeList(setAppGarments).finally();
		} catch (error) {
			printApiError(error);
		}
	};

	const renderEditDesignView = () => (
		<div className="select-component malerial-select-dropdown">
			<div>
				<CustomDropdown
					items={designLists}
					title="Select design"
					onItemClick={(item) => {
						onChangeMaterial(
							type,
							'productRefNumber',
							item?.productRefNumber,
							item?.productName,
							item?.productInfoForRfqId,
							item.orderQuantity,
							item.productId,
							idx,
							item?.isSetMember,
							item?.setName,
							item?.value
						);
					}}
					selectedItem={selectedDesign?.value}
				/>
			</div>
		</div>
	);

	const renderPlacement = () => {
		return (
			<CustomReactSelect
				type={isAdmin() ? 'CREATABLE' : ''}
				title={'Select'}
				onSetSelectedItem={(selectItem) => {
					setSelectedPlacement(selectItem);
					onUpdatePlacement(getSelectedPlacementIds(selectItem), idx, type);
				}}
				toolTipLength={35}
				allItems={appGarments}
				selectedValue={selectedPlacement}
				isMulti={true}
				isClearable={false}
				onCreateOption={(newPlacement) => {
					createAppGarmentsType(newPlacement, materialItem?.materialType);
				}}
				disabled={!materialItem.productRefNumber}
				randerCreateLabelJSX={(input) => (
					<div>
						<span className="semibold-14 gray_dark_01">Create:</span>{' '}
						<span className="regular-14 gray_dark_01">{input}</span>
					</div>
				)}
			/>
		);
	};

	const renderSupplierList = () => {
		return (
			<CustomDropdown
				type="SupplierList"
				title={'Select'}
				onItemClick={(selectItem) => {
					setIsSupplierChanged(true);
					onClickMaterial(idx, type, selectItem, 'SUPPLIER');
				}}
				items={supplierList}
				toolTipLength={18}
				selectedItem={materialItem?.supplierName}
				disabled={!materialItem.productRefNumber}
			/>
		);
	};

	const renderEditMaterialView = () => (
		<>
			<CustomDropdown
				title={'Material'}
				isFocus={true}
				type="addItem"
				isAddNew={true}
				onItemClick={(value) => {
					if (value.isAddNew) {
						onAddNewMaterialItem();
					} else {
						onClickMaterial(idx, type, value, 'MATERIAL');
					}
				}}
				items={materialsData}
				onItemSearch={(val) => onPopulateDynamicMaterials(type, materialItem, val)}
				selectedItem={materialItem?.materialName}
				isDisabled={false}
			/>

			{showAddNewModal &&
				(type === MATERIAL_TYPE.LIBRARY_FABRIC ? (
					<AddFabric
						isShow={true}
						onCloseModal={onCloseModal}
						// productId={materialItem.productId}
						onSelectItem={(item) => onClickMaterial(idx, type, item, 'MATERIAL')}
					/>
				) : type === MATERIAL_TYPE.TRIMS ? (
					// <AddTrims
					// 	isShow={true}
					// 	onCloseModal={onCloseModal}
					// 	// productId={materialItem.productId}
					// 	category={materialItem.trimsCategory}
					// 	onSelectItem={(item) => onClickMaterial(idx, type, item)}
					// />
					<TrimsAndAccessories
						isAdd={true}
						renderFrom={enumObj.DESIGNS}
						viewType={'Add'}
						title={MATERIAL_TITLE_NAME.TRIMS}
						isShow={true}
						onclose={onCloseModal}
						onSelectItem={(item) => onClickMaterial(idx, type, item, 'MATERIAL')}
					/>
				) : (
					// <AddNewBranding
					// 	isShow={true}
					// 	onCloseModal={onCloseModal}
					// 	// productId={materialItem.productId}
					// 	brandingCategory={materialItem.brandingCategory}
					// 	onSelectItem={(item) => onClickMaterial(idx, type, item)}
					// />
					<TrimsAndAccessories
						isAdd={true}
						renderFrom={enumObj.DESIGNS}
						viewType={'Add'}
						title={MATERIAL_TITLE_NAME.BRANDING}
						isShow={true}
						onclose={onCloseModal}
						onSelectItem={(item) => onClickMaterial(idx, type, item, 'MATERIAL')}
					/>
				))}
		</>
	);

	const renderEditUnitView = () => (
		<div className="d-flex f-consumption">
			<input
				type="number"
				name="unitConsumption"
				id="unitConsumption"
				min="1"
				onKeyPress={validateFloatNumber}
				placeholder="00"
				value={materialItem?.unitConsumption}
				onChange={(e) => onMaterialCategoryAndUnitChange(type, e.target.value, e.target.name, idx)}
			/>
			<select
				name="unitType"
				id="unitType"
				value={materialItem.unitType}
				onChange={(e) => onMaterialCategoryAndUnitChange(type, e.target.value, e.target.name, idx)}
			>
				<option value="">Select</option>
				{allUnitTypes?.map((unit) => {
					return (
						<option key={unit.constant} value={unit.constant}>
							{unit.name}
						</option>
					);
				})}
			</select>
		</div>
	);

	const renderEditImportView = () => {
		return (
			<select
				name="isImported"
				id="isImported"
				value={materialItem?.isImported === true ? 'Yes' : 'No'}
				onChange={(e) => onMaterialCategoryAndUnitChange(type, e.target.value, e.target.name, idx)}
			>
				{/* <option value="">Select</option> */}
				{['Yes', 'No'].map((item) => (
					<option key={item} value={item}>
						{item}
					</option>
				))}
			</select>
		);
	};

	const checkIsError = (errorInfo) => {
		if (errorInfo) return 'error-border-bottom';
		return '';
	};

	return (
		<>
			<tr>
				{isEditMaterial() || isAddMaterial() ? (
					<td className={checkIsError(errors?.designError)}>{renderEditDesignView()}</td>
				) : (
					<td>
						<div className="mb-1">
							{materialItem?.isPack && packTag()}
							{materialItem?.isSetMember && setTag()}
						</div>
						<p className="regular-14 gray_dark_01 mb-0">{materialItem.productName} </p>
						<span
							data-toggle="modal"
							data-target="#designViewModal"
							onClick={() => onClickDesignImage(materialItem.productId)}
							className="regular-12"
						>
							{materialItem.productRefNumber}{' '}
							{materialItem?.isSetMember && `(${materialItem?.setName})`}
						</span>
					</td>
				)}

				{isEditMaterial() || isAddMaterial() ? (
					<td className={checkIsError(errors?.type)} ref={placementRef}>
						<p className="regular-12 gray_dark_01 mb-0">{materialItem?.category}</p>
						{renderPlacement()}
					</td>
				) : (
					<td>
						<p className="regular-12 gray_dark_01 mb-0">{materialItem?.category}</p>
						{materialItem?.placementResponseList?.map((item) => (
							<span className="chip gray-chip" key={item?.id}>
								{item?.name}
							</span>
						))}
					</td>
				)}
				{isEditMaterial() || isAddMaterial() ? (
					<td className={checkIsError(errors?.materialError)}>
						{type === MATERIAL_TYPE.LIBRARY_FABRIC
							? !selectedPlacement?.length
								? 'Material'
								: renderEditMaterialView()
							: type === MATERIAL_TYPE.TRIMS
								? !selectedPlacement?.length
									? 'Material'
									: renderEditMaterialView()
								: type === MATERIAL_TYPE.BRANDING
									? !selectedPlacement?.length
										? 'Material'
										: renderEditMaterialView()
									: ''}
					</td>
				) : (
					<td>
						<span className="regular-14 gray_dark_01">{materialItem.materialName}</span>
					</td>
				)}

				{isEditMaterial() || isAddMaterial() ? (
					<td>{renderEditImportView()}</td>
				) : (
					<td>
						<span className="regular-14 gray_dark_01">
							{materialItem?.isImported ? 'Yes' : 'No'}
						</span>
					</td>
				)}

				{isEditMaterial() || isAddMaterial() ? (
					<td className={checkIsError(errors?.supplierError)}>{renderSupplierList()}</td>
				) : (
					<td>
						<span className="regular-14 gray_dark_01">{materialItem?.supplierName}</span>
					</td>
				)}

				{isEditMaterial() || isAddMaterial() ? (
					<td className={checkIsError(errors?.unitConsumptionError || errors?.unitTypeTypeError)}>
						{renderEditUnitView()}
					</td>
				) : (
					<td>
						<span className="regular-14 gray_dark_01">
							{materialItem.unitConsumption} {materialItem.unitTypeString}
						</span>
					</td>
				)}
				<td>
					<span className="regular-14 gray_dark_01">{materialItem.quantity}</span>
				</td>
				<td>
					<span className="regular-14 gray_dark_01">
						{isNaN(materialItem?.unitConsumption * materialItem?.quantity)
							? 0
							: (materialItem?.unitConsumption * materialItem?.quantity).toFixed(2)}
					</span>
					<span className="pl-2">{materialItem.unitTypeString}</span>
				</td>
				<td className="text-right">
					{isEditMaterial() || isAddMaterial() ? (
						<div className="d-flex justify-content-end">
							<span
								className="regular-14 primary_bright_01 cursor-pointer"
								onClick={() => {
									isSupplierChanged ? setIsSure(true) : onAddNew(idx, type);
								}}
							>
								{isEditMaterial() ? 'Update' : 'Add'}
							</span>
							<span
								className="regular-14 red cursor-pointer pl-2"
								onClick={() => onCancelEdit()}
							>
								Cancel
							</span>
						</div>
					) : (
						<div className="option">
							<div className="dropdown">
								<button
									className="btn btn-default dropdown-toggle"
									type="button"
									id="menu1"
									data-toggle="dropdown"
									aria-expanded="false"
								>
									<img
										src={`${process.env.PUBLIC_URL}/icons/more_icon.svg`}
										alt={`${process.env.PUBLIC_URL}/icons/more_icon.svg`}
									/>
								</button>
								<ul
									className="dropdown-menu dropdown-menu-right shadow-lg"
									role="menu"
									aria-labelledby="menu1"
									x-placement="bottom-end"
								>
									<li role="presentation" className="px-4 pb-3 pt-3">
										<span
											role="menuitem"
											tabIndex={-1}
											className="regular-14 primary_bright_01"
											onClick={() => onEditClick(type, idx)}
										>
											Edit
										</span>
									</li>
									<li role="presentation" className="px-4 pb-3 pt-3">
										<span
											role="menuitem"
											tabIndex={-1}
											className="regular-14 primary_bright_01"
											onClick={() => onDuplicateClick(type, idx, materialItem?.id)}
										>
											Duplicate
										</span>
									</li>
									<li role="presentation" className="px-4 pb-3">
										<span
											onClick={() => onRemoveItem(type, materialItem, idx)}
											role="menuitem"
											tabIndex={-1}
											className="regular-14 primary_bright_01"
										>
											Delete
										</span>
									</li>
								</ul>
							</div>
						</div>
					)}
				</td>
			</tr>
			{isSure && (
				<ConfirmationModal
					callback={() => {
						setIsSure(false);
						setIsSupplierChanged(false);
						onAddNew(idx, type);
					}}
					description="to change the supplier?"
					closeModal={() => {
						setIsSure(false);
						setIsSupplierChanged(false);
					}}
				/>
			)}
		</>
	);
};

export default SingleMaterial;
